// NOTE: NSAI-7391 — the skills marketplace contract, mirrored from the server's
// ISkillMarketplaceListingResponse (server/src/skill-marketplace).
export enum ESkillMarketplaceScope {
  ORGANIZATION = "organization",
  SELECTED_PROJECTS = "selected_projects",
}

export interface ISkillMarketplaceSkillSummary {
  uuid: string;
  name: string;
  description: string;
  isPublic: boolean;
  argumentHint: string | null;
}

// NOTE: One marketplace card. `isEnabledForMe` is what the chat acts on (the
// member's own choice, else the listing's default); `isMemberEnabled` is the raw
// choice, null until the member makes one.
export interface ISkillMarketplaceListing {
  listingUuid: string;
  accessScope: ESkillMarketplaceScope;
  isDefault: boolean;
  isEnabledForMe: boolean;
  isMemberEnabled: boolean | null;
  // NOTE: false for a listing its publisher manages but cannot use from this
  // project — the skill is disabled, archived or has no saved version, or the
  // selected-projects scope leaves this project out.
  isUsable: boolean;
  isManageable: boolean;
  publishedAt: string;
  publishedByFirstName: string | null;
  publishedByLastName: string | null;
  sourceProjectUuid: string | null;
  sourceProjectTitle: string | null;
  targetProjectUuids: string[];
  skill: ISkillMarketplaceSkillSummary;
}

export interface IPublishSkillMarketplacePayload {
  accessScope?: ESkillMarketplaceScope;
  isDefault?: boolean;
  targetProjectUuids?: string[];
}

export interface IPublishSkillMarketplaceParams {
  skillUuid: string;
  data: IPublishSkillMarketplacePayload;
}

export interface IUpdateSkillMarketplacePreferenceParams {
  listingUuid: string;
  isEnabled: boolean;
}

// NOTE: The publish dialog's editable state, identical in shape on web and
// mobile.
export interface IPublishSkillMarketplaceDraft {
  accessScope: ESkillMarketplaceScope;
  isDefault: boolean;
  targetProjectUuids: string[];
}

export interface ICanBrowseSkillMarketplaceProps {
  isPersonalProject: boolean;
  hasMarketplaceSkillReadPermission: boolean;
  hasMarketplaceSkillWritePermission: boolean;
}

export interface IIsSkillMarketplaceActionOfferedProps {
  isListed: boolean;
  isSkillEnabled: boolean;
  isSkillArchived: boolean;
}

export interface ICanPublishSkillToMarketplaceProps {
  isPersonalProject: boolean;
  hasMarketplaceSkillWritePermission: boolean;
  // NOTE: The server's publisher rule — the owner of a private skill, or a
  // holder of public_skill:write for a public one.
  isSkillOwner: boolean;
  isSkillPublic: boolean;
  hasPublicSkillWritePermission: boolean;
  // NOTE: A managed copy installed from the organization catalog is read-only
  // and the server refuses to publish it.
  isCatalogManagedCopy: boolean;
}

export interface IFilterSkillMarketplaceListingsProps {
  listings: ISkillMarketplaceListing[] | null | undefined;
  search: string;
}
